import dayjs from "dayjs";
import IndeterminateCheckbox from "../components/Table/InderterminateCheckbox";
import { booleanFilterSelect, numberFinderFilter } from "../components/Table/utils/modelUtils";
import { formatFecha, formatoNumero, withoutDots } from "../helpers/FormatFecha";
import NumberFormat from "react-number-format";
import { TableCell } from "./TableCell";
// handlecheckabono
export const columnasAplicaionDoc = ({selectAplicacionDoc = [], setRowsDoc, rowsDoc = [], tempRows = [] }) => [
    {
        id: 'select',
        header: ()=>(
          <span></span>
        ),
        accessorFn: (row)=>{ return (selectAplicacionDoc ?? []).map(d=>d.index).includes(row.index) },
        cell: ({ row }) =>(
           <IndeterminateCheckbox
            checked={row.getIsSelected() || row.original.seleccionado}
            indeterminate={row.getIsSomeSelected()}
            onChange={(e)=>{
                row.getToggleSelectedHandler()(e)
                const index = rowsDoc.findIndex( item => item.index === row.original.index)
                const indexTemp = tempRows.findIndex( item => item.index === row.original.index)
                const ndocs = [...rowsDoc]
                const ndocsTemp = [...tempRows]
                ndocs[index]['seleccionado'] = e.target.checked
                ndocsTemp[indexTemp]['seleccionado'] = e.target.checked
                setRowsDoc((prev)=>({
                    ...prev,
                    rows: ndocs,
                    tempRows: ndocsTemp
                }))
            }}
            disabled={row.original.pagoTransito > 0}
           />
        ),
         meta: {
          filterType: 'boolean-filter'
        },
        enableColumnFilter: false,
        enableGrouping: false,
        // filterFn: booleanFilterSelect,
    },
    { 
        id: "dcto", 
        header: "Doc", 
        accessorKey: "dcto",  
        cell: ({row})=>(
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.getValue("dcto")}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id: "estDoc", 
        header: "Estado", 
        accessorKey: "estDoc", 
        cell: ({row})=>(
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.getValue("estDoc")}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id: "nroDoc", 
        header: "Nro. Doc", 
        accessorKey: "nroDoc", 
        cell: ({row})=>(
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.getValue("nroDoc")}
            </TableCell>
        ),
        enableColumnFilter: false, 
        enableGrouping: false
    },
    { 
        id: "vctoNom",
        header: "Vcto.", 
        accessorKey: "vctoNom", 
        sortingFn: (a,b) =>{
            const ad = dayjs(formatFecha(a.original.vctoNom), 'DD/MM/YYYY')
            const bd = dayjs(formatFecha(b.original.vctoNom), 'DD/MM/YYYY')
            return (ad.valueOf()-bd.valueOf() > 0) ? 1 : (ad.valueOf()-bd.valueOf() < 0) ? -1 : 0;
        },
        cell: ({row})=>(
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.getValue("vctoNom")}
            </TableCell>
        ),
        enableColumnFilter: false, 
        enableGrouping: false
    },
    { 
        id:'montoDcto',
        header: "Monto", 
        // accessorKey: "montoDcto", 
        accessorFn: row=> formatoNumero(row.montoDcto),
        sortingFn: (a,b) =>{
            const ad = a.original.montoDcto.toString();
            const bd = b.original.montoDcto.toString();
            return (Number(ad.replace(/[.]/g,"")) < Number(bd.replace(/[.]/g,""))) ? -1 : (Number(ad.replace(/[.]/g,"")) > Number(bd.replace(/[.]/g,""))) ? 1 : 0
        },
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                <span className="pull-right">{formatoNumero(row.original.montoDcto)}</span>
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:'saldoPendiente',
        header: "Saldo",
        // accessorKey: "saldoPendiente",
        accessorFn: row=> formatoNumero(row?.saldoPendiente),
        sortingFn: (a,b) =>{
            const ad = a.original.saldoPendiente.toString();
            const bd = b.original.saldoPendiente.toString();
            return (Number(ad.replace(/[.]/g,"")) < Number(bd.replace(/[.]/g,""))) ? -1 : (Number(ad.replace(/[.]/g,"")) > Number(bd.replace(/[.]/g,""))) ? 1 : 0
        },
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                <span className="pull-right">
                {formatoNumero(row.original.saldoPendiente)}
                </span>
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:'abono',
        header: "Abono", 
        accessorKey: "abono",
        cell:(info)=>{
            // setRowsDoc, rowsDoc
            const index = rowsDoc.findIndex( item => item.index === info.row.original.index)
            const indexTemp = tempRows.findIndex( item => item.index === info.row.original.index)
            return <NumberFormat
            name='_chkDocumento'
            value={formatoNumero(info.getValue())}
            // data-key={info.row.original.idcheck}
            onChange={(e) => {
                let ndocs = [...rowsDoc]
                let ndocsTemp = [...tempRows]
                ndocs[index]['abono'] = Number(withoutDots(e.target.value))
                ndocsTemp[indexTemp]['abono'] = Number(withoutDots(e.target.value))
                setRowsDoc((prev)=>({
                    ...prev,
                    rows: ndocs,
                    tempRows: ndocsTemp
                }))
            }}
            style={{ width: "120px" }}
            displayType={"input"}
            decimalScale={0}
            allowNegative={false}
            thousandSeparator={"."}
            decimalSeparator={","}
        />
        },
        meta: {
            filterType: 'number-finder'
        },
        enableColumnFilter: false,
        enableGrouping: false,
        enableSorting: false,
        // filterFn: numberFinderFilter,
    },
    { 
        id:'mora',
        header: "Mora", 
        // accessorKey: "mora",     
        accessorFn: row=> formatoNumero(row?.mora),
        sortingFn: (a,b) =>{
            const ad = a.original.mora.toString();
            const bd = b.original.mora.toString();
            return (Number(ad.replace(/[.]/g,"")) < Number(bd.replace(/[.]/g,""))) ? -1 : (Number(ad.replace(/[.]/g,"")) > Number(bd.replace(/[.]/g,""))) ? 1 : 0
        },
        cell:({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                <span className="pull-right">{formatoNumero(row.original.mora)}</span>
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:"dias_Mora",
        header: "Días Mora", 
        // accessorKey: "dias_Mora", 
        accessorFn: row=> row?.dias_Mora,
        sortingFn: (a,b) =>{
            const ad = a.original.dias_Mora.toString();
            const bd = b.original.dias_Mora.toString();
            return (Number(ad.replace(/[.]/g,"")) < Number(bd.replace(/[.]/g,""))) ? -1 : (Number(ad.replace(/[.]/g,"")) > Number(bd.replace(/[.]/g,""))) ? 1 : 0
        },
        cell: ({row})=>(
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.getValue("dias_Mora")}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:"estadoCobranza", 
        header: "Estado cobranza", 
        accessorKey: "estadoCobranza", 
        cell: ({row})=>(
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.getValue("estadoCobranza")}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:"interes",
        header: "Interés", 
        accessorKey: "interes",
        cell: ({row})=>(
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.getValue("interes")}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:"tmc", 
        header: "TMC", 
        accessorKey: "tmc", 
        cell: ({row})=>(
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.getValue("tmc")}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:"fao_Num_Ope",
        header: "Operación", 
        // accessorKey: "fao_Num_Ope", 
        accessorFn: row=> row?.fao_Num_Ope,
        sortingFn: (a,b) =>{
            const ad = a.original.fao_Num_Ope.toString();
            const bd = b.original.fao_Num_Ope.toString();
            return (Number(ad.replace(/[.]/g,"")) < Number(bd.replace(/[.]/g,""))) ? -1 : (Number(ad.replace(/[.]/g,"")) > Number(bd.replace(/[.]/g,""))) ? 1 : 0
        },
        cell: ({row})=>(
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.getValue("fao_Num_Ope")}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:"pagoTransito",
        header: "Pago Tránsito", 
        // accessorKey: "pagoTransito",
        accessorFn: row=> formatoNumero(row?.pagoTransito),
        sortingFn: (a,b) =>{
            const ad = a.original.pagoTransito.toString();
            const bd = b.original.pagoTransito.toString();
            return (Number(ad.replace(/[.]/g,"")) < Number(bd.replace(/[.]/g,""))) ? -1 : (Number(ad.replace(/[.]/g,"")) > Number(bd.replace(/[.]/g,""))) ? 1 : 0
        },
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                <span className="pull-right">{formatoNumero(row.original.pagoTransito)}</span>
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    }
];

export const columnasAplicaionCXC = ({selectAplicacionCxc = [], rowsCxc = [], setRowsCxc, tempRows = [] }) => [
	{ 
        id: 'select1',
        header: ()=>(
          <span></span>
        ),
        accessorFn: (row)=>{ return (selectAplicacionCxc ?? []).map(d=>d.index).includes(row.index) },
        cell: ({ row }) =>(
          <IndeterminateCheckbox
           checked={row.getIsSelected() || row.original.seleccionado}
           indeterminate={row.getIsSomeSelected()}
            onChange={(e)=>{
                const index = rowsCxc.findIndex( item => item.index === row.original.index)
                const indexTemp = tempRows.findIndex( item => item.index === row.original.index)
                const ndocs = [...rowsCxc]
                const ndocsTemp = [...tempRows]
                ndocs[index]['seleccionado'] = e.target.checked
                ndocsTemp[indexTemp]['seleccionado'] = e.target.checked
                // console.log('---<e></e>', e, e.target.checked)
                setRowsCxc((prev)=>({
                    ...prev,
                    rows: ndocs,
                    tempRows: ndocsTemp
                }))
                row.getToggleSelectedHandler()(e)
            }}
            disabled={row.original.pagoTransito > 0}
          />
       ),
        meta: {
          filterType: 'boolean-filter'
        },
        enableColumnFilter: false,  
        enableGrouping: false,
        filterFn: booleanFilterSelect,
    },
    { 
        id: 'ctaxCobrar',
        header: "Descripción", 
        accessorKey: "ctaxCobrar", 
        cell: ({row})=>(
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.getValue("ctaxCobrar")}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false 
    },
    { 
        id:'fecha',
        header: "Fecha",
        accessorKey: "fecha",
        cell: ({row})=>(
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.getValue("fecha")}
            </TableCell>
        ),
        sortingFn: (a,b) =>{
            const ad = dayjs(formatFecha(a.original.fecha), 'DD/MM/YYYY')
            const bd = dayjs(formatFecha(b.original.fecha), 'DD/MM/YYYY')
            return (ad.valueOf()-bd.valueOf() > 0) ? 1 : (ad.valueOf()-bd.valueOf() < 0) ? -1 : 0;
        },
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:'monto',
        header: "Monto",
        accessorFn: row=> formatoNumero(row.monto),
        sortingFn: (a,b) =>{
            const ad = a.original.monto.toString();
            const bd = b.original.monto.toString();
            return (Number(ad.replace(/[.]/g,"")) < Number(bd.replace(/[.]/g,""))) ? -1 : (Number(ad.replace(/[.]/g,"")) > Number(bd.replace(/[.]/g,""))) ? 1 : 0
        },
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {formatoNumero(row.original.monto)}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:'saldoText',
        header: "Saldo", 
        accessorFn: row=> formatoNumero(row.saldo),
        sortingFn: (a,b) =>{
            const ad = a.original.saldo.toString();
            const bd = b.original.saldo.toString();
            return (Number(ad.replace(/[.]/g,"")) < Number(bd.replace(/[.]/g,""))) ? -1 : (Number(ad.replace(/[.]/g,"")) > Number(bd.replace(/[.]/g,""))) ? 1 : 0
        },
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {formatoNumero(row.original.saldo)}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:'abono', 
        header: "Abono", 
        accessorKey: "abono",
        cell:(info)=>{
            // rowsCxc = [], setRowsCxc
            const index = rowsCxc.findIndex( item => item.index === info.row.original.index)
            const indexTemp = tempRows.findIndex( item => item.index === info.row.original.index)
            return <NumberFormat
            name='_chkCuentas'
            value={formatoNumero(info.getValue())}
            // data-key={info.row.original.idcheck}
            onChange={(e) => {
                let ndocs = [...rowsCxc]
                let ndocsTemp = [...tempRows]
                ndocs[index]['abono'] = Number(withoutDots(e.target.value))
                ndocsTemp[indexTemp]['abono'] = Number(withoutDots(e.target.value))
                setRowsCxc((prev)=>({
                    ...prev,
                    rows: ndocs,
                    tempRows: ndocsTemp
                }))
            }}
            style={{ width: "120px" }}
            displayType={"input"}
            decimalScale={0}
            allowNegative={false}
            thousandSeparator={"."}
            decimalSeparator={","}
        />
        },
        meta: {
            filterType: 'number-finder'
        },
        enableColumnFilter: false,
        enableGrouping: false,
        enableSorting: false,
        filterFn: numberFinderFilter,
    },
    { 
        id:'cxC_RUT_DEU',
        header: "Rut Deudor", 
        accessorKey: "cxC_RUT_DEU", 
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.original.cxC_RUT_DEU}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false,
    },
    { 
        id:'cxC_NUM_CTA', 
        header: "Num Cta.", 
        accessorKey: "cxC_NUM_CTA",
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.original.cxC_NUM_CTA}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false 
    },
    { 
        id:'cxC_NUM_OPE',
        header: "Num. Ope.", 
        accessorKey: "cxC_NUM_OPE", 
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.original.cxC_NUM_OPE}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:'pagoTransito',
        header: "Pago Tránsito", 
        accessorFn: row=> formatoNumero(row.pagoTransito),
        sortingFn: (a,b) =>{
            const ad = a.original.pagoTransito.toString();
            const bd = b.original.pagoTransito.toString();
            return (Number(ad.replace(/[.]/g,"")) < Number(bd.replace(/[.]/g,""))) ? -1 : (Number(ad.replace(/[.]/g,"")) > Number(bd.replace(/[.]/g,""))) ? 1 : 0
        },
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {formatoNumero(row.original.pagoTransito)}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:'estadoCobranza',
        header: "Estado cobranza", 
        accessorKey: "estadoCobranza", 
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.original.estadoCobranza}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    // { 
    //     id:'estadoCobranza',
    //     header: "Total a Pagar", 
    //     accessorKey: "estadoCobranza", 
    //     cell: ({row})=> (
    //         <TableCell
    //             obligatorio={row?.original?.obligatorio}    
    //         >
    //             {row.original.estadoCobranza}
    //         </TableCell>
    //     ),
    //     enableColumnFilter: false,  
    //     enableGrouping: false
    // }
];

export const columnasAplicaionLeasing = ({ selectAplicaionLeasing = [], rowsLeasing = [], setRowsLeasing, tempRows = [] }) => [
	{ 
        id: 'select1',
        header: ()=>(
          <span></span>
        ),
        accessorFn: (row)=>{ return (selectAplicaionLeasing ?? []).map(d=>d.index).includes(row.index) },
        cell: ({ row }) =>(
            <IndeterminateCheckbox
                checked={row.getIsSelected() || row.original.seleccionado}
                indeterminate={row.getIsSomeSelected()}
                onChange={(e)=>{
                    const index = rowsLeasing.findIndex( item => item.index === row.original.index)
                    const indexTemp = tempRows.findIndex( item => item.index === row.original.index)
                    const ndocs = [...rowsLeasing]
                    const ndocsTemp = [...tempRows]
                    ndocs[index]['seleccionado'] = e.target.checked
                    ndocsTemp[indexTemp]['seleccionado'] = e.target.checked
                    // console.log('---<e></e>', e, e.target.checked)
                    setRowsLeasing((prev)=>({
                        ...prev,
                        rows: ndocs,
                        tempRows: ndocsTemp
                    }))
                    row.getToggleSelectedHandler()(e)
                }}
                disabled={row.original.pago_transito > 0}
           />
       ),
        meta: {
          filterType: 'boolean-filter'
        },
        enableColumnFilter: false,  
        enableGrouping: false,
        filterFn: booleanFilterSelect,
    },
    { 
        id:'operacion',
        header: "Operación", 
        accessorKey: "operacion", 
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.original.operacion}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:'num_cuota',
        header: "Nro. Cuota.",
        accessorKey: "num_cuota",
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.original.num_cuota}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false 
    },
    { 
        id:'fecha_vencimiento',
        header: "Vencimiento",
        accessorKey: "fecha_vencimiento",
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {row.original.fecha_vencimiento}
            </TableCell>
        ),
        sortingFn: (a,b) =>{
            const ad = dayjs(formatFecha(a.original.fecha_vencimiento), 'DD/MM/YYYY')
            const bd = dayjs(formatFecha(b.original.fecha_vencimiento), 'DD/MM/YYYY')
            return (ad.valueOf()-bd.valueOf() > 0) ? 1 : (ad.valueOf()-bd.valueOf() < 0) ? -1 : 0;
        },
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:'saldo_cuota_total',
        header: "Saldo", 
        accessorFn: row=> formatoNumero(row.saldo_cuota_total),
        sortingFn: (a,b) =>{
            const ad = a.original.saldo_cuota_total.toString();
            const bd = b.original.saldo_cuota_total.toString();
            return (Number(ad.replace(/[.]/g,"")) < Number(bd.replace(/[.]/g,""))) ? -1 : (Number(ad.replace(/[.]/g,"")) > Number(bd.replace(/[.]/g,""))) ? 1 : 0
        },
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {formatoNumero(row.original.saldo_cuota_total)}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:'abono', 
        header: "Abono", 
        accessorKey: "abono",
        cell:(info)=>{
            const index = rowsLeasing.findIndex( item => item.index === info.row.original.index)
            const indexTemp = tempRows.findIndex( item => item.index === info.row.original.index)
            return <NumberFormat
            name='_chkCuentas'
            value={formatoNumero(info.getValue())}
            // data-key={info.row.original.idcheck}
            onChange={(e) => {
                let ndocs = [...rowsLeasing]
                let ndocsTemp = [...tempRows]
                ndocs[index]['abono'] = Number(withoutDots(e.target.value))
                ndocsTemp[indexTemp]['abono'] = Number(withoutDots(e.target.value))
                setRowsLeasing((prev)=>({
                    ...prev,
                    rows: ndocs,
                    tempRows: ndocsTemp
                }))
            }}
            style={{ width: "120px" }}
            displayType={"input"}
            decimalScale={0}
            allowNegative={false}
            thousandSeparator={"."}
            decimalSeparator={","}
            />
        },
        meta: {
            filterType: 'number-finder'
        },
        enableColumnFilter: false,
        enableGrouping: false,
        enableSorting: false,
        filterFn: numberFinderFilter,
    },
    { 
        id:'interes',
        header: "Interés", 
        accessorKey: "interes",
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {formatoNumero(row.original.interes)}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:'gasto_cob',
        header: "Gasto cob", 
        accessorKey: "gasto_cob",
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
                {formatoNumero(row.original.gasto_cob)}
            </TableCell>
        ), 
        enableColumnFilter: false,  
        enableGrouping: false
     },
    { 
        id:'total_a_pagar', 
        header: "Total a pagar", 
        accessorKey: "total_a_pagar",
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
               {formatoNumero(row.original.total_a_pagar)}
            </TableCell>
        ), 
        enableColumnFilter: false,  
        enableGrouping: false
    },
    { 
        id:'pago_transito',
        header: "Pago Tránsito", 
        accessorFn: row=> formatoNumero(row.pago_transito),
        sortingFn: (a,b) =>{
            const ad = a.original.pago_transito.toString();
            const bd = b.original.pago_transito.toString();
            return (Number(ad.replace(/[.]/g,"")) < Number(bd.replace(/[.]/g,""))) ? -1 : (Number(ad.replace(/[.]/g,"")) > Number(bd.replace(/[.]/g,""))) ? 1 : 0
        },
        cell: ({row})=> (
            <TableCell
                obligatorio={row?.original?.obligatorio}    
            >
            {formatoNumero(row.original.pago_transito)}
            </TableCell>
        ),
        enableColumnFilter: false,  
        enableGrouping: false
    },
];